<template>
  <v-app :class="layout" :style="`background: url('${bgUrl}') no-repeat 50% 50%`">
    <v-content>
      <v-progress-linear v-show="loading" :indeterminate="true" class="page-loader"></v-progress-linear>
      <v-container fluid fill-height>

        <template v-if="layout === 'menu_top' && !extranet">
          <v-navigation-drawer v-model="sidebar" app temporary class="left-menu__list">
            <v-list class="pa-0" v-if="user">
              <v-list-tile avatar>
                <v-list-tile-avatar>
                  <div class="user-avatar primary">{{ userAvatar }}</div>
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title>
                    <span class="ava-name">{{ user.full_name }}</span>
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider></v-divider>
            </v-list>

            <v-list>
              <v-list-tile v-for="item in menuItems" :key="item.title" :to="item.path">
                <v-list-tile-action>
                  <font-awesome-icon :icon="item.icon" class="size-24"/>
                </v-list-tile-action>
                <v-list-tile-content>{{ item.mobileTitle ? item.mobileTitle : item.title }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile v-if="isAuthenticated && epsCartLength" to="/eps-cart">
                <v-list-tile-action>
                  <v-badge right>
                    <span slot="badge">{{epsCartLength}}</span>
                    <font-awesome-icon icon="shopping-basket" class="size-24"/>
                  </v-badge>
                </v-list-tile-action>
                <v-list-tile-content>Корзина</v-list-tile-content>
              </v-list-tile>
              <v-list-tile v-if="isAuthenticated" to="/notifications">
                <v-list-tile-action>
                  <v-badge right>
                    <span v-if="newMobileNotifications.length" slot="badge">
                      {{newMobileNotifications.length}}
                    </span>
                    <font-awesome-icon icon="bell" class="size-24"/>
                  </v-badge>
                </v-list-tile-action>
                <v-list-tile-content>Уведомления</v-list-tile-content>
              </v-list-tile>
              <v-list-tile v-if="isAuthenticated" @click="UserLogout">
                <v-list-tile-action>
                  <font-awesome-icon icon="sign-out-alt" class="size-24 ico-reverse"/>
                </v-list-tile-action>
                <v-list-tile-content>Выход</v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-navigation-drawer>
        </template>

        <template v-if="layout === 'menu_left' && !extranet">
          <v-navigation-drawer v-model="sidebar" app :permanent="$vuetify.breakpoint.lgAndUp" class="left-menu__list">
            <v-list class="primary" v-if="user" dark>
              <v-list-tile avatar>
                <v-list-tile-avatar>
                  <div class="user-avatar">{{ userAvatar }}</div>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>
                    <span class="ava-name">{{ user.full_name }}</span>
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>

            <v-list>
              <v-list-tile v-for="item in menuItems" :key="item.title" :to="item.path">
                <v-list-tile-action>
                  <font-awesome-icon :icon="item.icon" class="size-24"/>
                </v-list-tile-action>
                <v-list-tile-content>
                  {{ item.mobileTitle ? item.mobileTitle : item.title }}
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile v-if="isAuthenticated && epsCartLength" to="/eps-cart">
                <v-list-tile-action>
                  <v-badge right>
                    <span slot="badge">{{epsCartLength}}</span>
                    <font-awesome-icon icon="shopping-basket" class="size-24"/>
                  </v-badge>
                </v-list-tile-action>
                <v-list-tile-content>Корзина</v-list-tile-content>
              </v-list-tile>

              <v-list-tile v-if="isAuthenticated" to="/notifications">
                <v-list-tile-action>
                  <v-badge right>
                    <span v-if="newMobileNotifications.length" slot="badge">
                      {{newMobileNotifications.length}}
                    </span>
                    <font-awesome-icon icon="bell" class="size-24"/>
                  </v-badge>
                </v-list-tile-action>
                <v-list-tile-content>Уведомления</v-list-tile-content>
              </v-list-tile>

              <v-list-tile v-if="isAuthenticated" @click="UserLogout">
                <v-list-tile-action>
                  <font-awesome-icon icon="sign-out-alt" class="size-24 ico-reverse"/>
                </v-list-tile-action>
                <v-list-tile-content>Выход</v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-navigation-drawer>
        </template>

        <v-toolbar app text-md-center id="header" class="px-2">
          <span class="top-menu-btn" v-if="!extranet">
            <v-toolbar-side-icon @click="sidebar = !sidebar"></v-toolbar-side-icon>
          </span>

          <v-toolbar-title>
            <router-link :to="isAuthenticated ? '/dashboard' : '/'" tag="div" class="logo-wraper mr-2" style="position: relative;float: left;">
              <img :src="logoUrl || '/static/logo_sds.png'" id="nav-logo"/>
            </router-link>
            <small v-show="!isAuthenticated" style="float: right;position: relative;top: 12px;">Программа лояльности для сотрудников партнеров и их клиентов</small>
          </v-toolbar-title>

          <template v-if="layout === 'menu_top'">
            <v-spacer></v-spacer>
            <v-toolbar-items
              :class="`${menuItems.length > 10 ? 'hide-home' : '' } hidden-md-and-down md-padding menu__list`">
              <v-btn
                flat
                v-for="item in menuItems"
                :key="item.title"
                :to="item.path"
                :class="`${item.dopClass ? item.dopClass : ''} menu-btn`"
              >
                <font-awesome-icon :icon="item.icon"/>
                <span class="ml-2 menu-title">{{ item.title }}</span>
              </v-btn>
              <v-btn flat to="/eps-cart" v-if="isAuthenticated && epsCartLength"
                     v-tooltip.bottom="'Сертификаты в корзине на сумму: ' + epsCartSummary">
                <v-badge right>
                  <span slot="badge">{{epsCartLength}}</span>
                  <font-awesome-icon icon="shopping-basket"/>
                </v-badge>
              </v-btn>
              <v-btn flat to="/notifications" v-if="isAuthenticated" class="menu-btn notify long-title">
                <v-badge right>
                  <span v-if="newMobileNotifications.length" slot="badge">
                    {{newMobileNotifications.length}}
                  </span>
                </v-badge>
                <font-awesome-icon icon="bell"/>
                <span class="ml-2 menu-title">Уведомления</span>
              </v-btn>
              <v-btn v-if="isAuthenticated" flat @click="UserLogout" class="menu-btn">
                <font-awesome-icon icon="sign-out-alt"/>
                <span class="ml-2 menu-title">Выход</span>
              </v-btn>
            </v-toolbar-items>
          </template>
        </v-toolbar>

        <transition name="fade" mode="out-in">
          <router-view class="view"></router-view>
        </transition>

        <notifications group="error" position="bottom center" width="500px" animation-type="velocity"/>
        <notifications group="info" position="bottom center" width="500px" animation-type="velocity"/>

      </v-container>
    </v-content>

    <Webpush v-show="showWebpushPopup"/>

    <v-footer id="footer" app height="auto" class="pa-2">
      <v-layout max justify-space-between align-center>
        <span class="pl-1 pr-1">© ООО "Лоялти сервис"</span>
        <span class="pl-1 pr-1"><router-link :to="'/page/rules'" tag="a" class="white--text">
          Правила мотивационной программы
        </router-link></span>
        <span class="pl-1 pr-1"><img src="@/assets/images/logo_ms.png"/></span>
      </v-layout>
    </v-footer>
  </v-app>
</template>

<script>
  import Webpush from './pages/profile/webpush/Webpush.vue';

  export default {
    data() {
      return {
        sidebar: false,
      };
    },
    components: {
      Webpush,
    },
    computed: {
      user() {
        return this.$store.state.user;
      },
      userAvatar() {
        return this.$store.state.user.full_name.split(' ').map(x => x[0]).join('');
      },
      userBalance() {
        return this.$store.state.user ? this.$store.state.user.balance : null;
      },
      isAuthenticated() {
        return this.$store.getters.isAuthenticated;
      },
      loading() {
        return this.$store.state.loading;
      },
      epsCartLength() {
        return this.$store.state.eps.cartLength;
      },
      epsCartSummary() {
        return this.$store.state.eps.cartSummary;
      },
      extranet() {
        return this.$store.state.settings.extranet === true;
      },
      layout() {
        return this.$store.state.settings.layout;
      },
      logoUrl() {
        return this.$store.state.settings.logoUrl;
      },
      bgUrl() {
        return this.$store.state.settings.bgUrl;
      },
      showWebpushPopup() {
        return 'Notification' in window
          && this.$store.state.user
          && this.$store.state.settings.webpush === true
          && this.$store.state.webpush.webpushPopupOpened === true
          && this.$store.state.webpush.webpushFirebaseToken === null
          && this.$store.state.webpush.webpushDeclinedAt === null;
      },
      news() {
        return this.$store.state.settings.news === true;
      },
      instructions() {
        return this.$store.state.settings.instructions === true;
      },
      sales() {
        return this.$store.state.settings.sales === true;
      },
      courses() {
        return this.$store.state.settings.courses === true;
      },
      tickets() {
        return this.$store.state.settings.module_tickets === true;
      },
      isBannersOn() {
        return this.$store.state.settings.module_banners === true;
      },
      newMobileNotifications() {
        return this.$store.state.mobileNotifications.notificationsNew;
      },
      menuItems() {
        if (this.isAuthenticated) {
          const menu = [
            { title: null, path: '/dashboard', icon: 'home', mobileTitle: 'Личный кабинет', dopClass: 'home' },
            { title: this.userBalance, path: '/purse', icon: 'ruble-sign', dopClass: 'number' },
            { title: 'Профиль', path: '/profile', icon: 'user-circle' },
            { title: 'Помощь', path: '/feedback', icon: 'question-circle' },
            { title: 'Каталог', path: '/prizes', icon: 'gift' },
            { title: 'Заказы', path: '/orders', icon: 'file-alt' },
          ];
          this.news && menu.push({ title: 'Акции', path: '/news', icon: 'newspaper' });
          this.instructions && menu.push({ title: 'Презентации', path: '/instructions', icon: 'chalkboard-teacher', dopClass: 'long-title' });
          this.sales && menu.push({ title: 'Продажи', path: '/sales', icon: 'shopping-cart' });
          this.courses && menu.push({ title: 'Обучение', path: '/courses', icon: 'user-graduate' });
          this.tickets && menu.push({ title: 'Чат', path: '/tickets', icon: 'comments' });
          return menu;
        }
        if (this.extranet) {
          return [];
        }
        return [
          { title: null, path: '/', icon: 'home', mobileTitle: 'Главная страница' },
          { title: 'Помощь', path: '/feedback', icon: 'question-circle' },
          { title: 'Регистрация', path: '/register', icon: 'user-shield', dopClass: 'long-title' },
          { title: 'Войти', path: '/login', icon: 'sign-in-alt' },
        ];
      },
    },
    methods: {
      UserLogout() {
        this.$store.dispatch('UserLogout');
        this.$router.push('/');
      },
    },
    created() {
      this.$store.dispatch('GetSettings');
      this.$store.commit('SetLoading', false);
      this.user && this.$store.dispatch('mobileNotifications/GetNotifications', this.user.profile_id);
      this.isBannersOn && this.$store.dispatch('banners/GetBannersList');
    },
  };
</script>
